import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const SCRIPT_URL = 'https://app.revenuehero.io/scheduler.min.js';

const RevenueHeroBookMeeting = ({ formId, routerId }) => {
  const [isHubspotLoaded, setIsHubspotLoaded] = useState(false);
  const [isRHLoaded, setIsRHLoaded] = useState(false);
  const revenueHeroRef = useRef(null);

  useEffect(() => {
    if (isHubspotLoaded && isRHLoaded && window?.RevenueHero && routerId && formId) {
      // eslint-disable-next-line no-undef
      revenueHeroRef.current = new RevenueHero({ routerId });
      // window.hero.dialog.setEmbedTarget('#embedDiv');
      revenueHeroRef.current.schedule(`hsForm_${formId}`);
    }
  }, [isHubspotLoaded, isRHLoaded, routerId, formId]);

  useEffect(() => {
    // Check if the script already exists in the document
    const existingScript = document.querySelector(`script[src="${SCRIPT_URL}"]`);

    if (existingScript) {
      // If the script already exists, set it as loaded
      setIsRHLoaded(true);
    } else {
      // Create a script element if not already loaded
      const script = document.createElement('script');
      script.src = SCRIPT_URL;
      script.async = true;

      // Set script as loaded once it finishes loading
      script.onload = () => {
        setIsRHLoaded(true);
      };

      // Append the script to the body
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    const onMessage = (ev) => {
      if (ev.data.type === 'hsFormCallback' && ev.data.eventName === 'onFormReady') {
        if (ev.data.id === formId) {
          setIsHubspotLoaded(true);
        }
      }

      if (ev.data.type === 'MEETING_BOOKED' || ev.data.type === 'MEETING_RESCHEDULED') {
        window?.scrollTo(0, 0);
        setTimeout(() => {
          revenueHeroRef.current?.dialog?.close(); // Close the modal
        }, 4000);
      }
    };
    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, [formId]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};

RevenueHeroBookMeeting.propTypes = {
  formId: PropTypes.string.isRequired,
  routerId: PropTypes.number.isRequired,
};

export default RevenueHeroBookMeeting;
